// components/modals/VideoModal.js
import React, { useEffect } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";

const VideoModal = ({ show, handleClose, videoSrc }) => {
  useEffect(() => {
    // Automatically start playing the video when the modal is shown
    const video = document.getElementById("introVideo");
    if (video) {
      video.play();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Introduction Video</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body style={{ textAlign: "center" }}>
        <video
          id="introVideo"
          width="100%"
          controls
          autoPlay
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VideoModal;
